/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var DepEnforcementEditDetailsView = require('../views/DepEnforcementEditDetailsView');

var GetEnforcement = require('../services/GetEnforcement');
var GetAllEnforcementLookups = require('../services/GetAllEnforcementLookups');
var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');

module.exports = function(entityId, enforcementId) {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetEntityIdentifiers(entityId), GetEnforcement(enforcementId))
    .done(function(entityIdentifiers, enforcement) {
      GetAllEnforcementLookups(entityIdentifiers.categoryId, entityIdentifiers.entityTypeId)
        .done(function(enforcementLookups) {
          NavUtils.navigate('dep/entity/' + entityId + '/enforcement/' + enforcementId + '/edit-details');
          Scaffold.content.show(
            new DepEnforcementEditDetailsView({
              viewMode: 'int',
              model: new Backbone.Model({
                entityId: entityId,
                entityIdentifiers: entityIdentifiers,
                enforcementId: enforcementId,
                enforcement: enforcement,
                actions: enforcementLookups.enforcementActionActions,
                agencies: enforcementLookups.enforcementActionAgencies,
                statuses: enforcementLookups.enforcementActionStatuses,
                types: enforcementLookups.enforcementActionTypes,
                areas: enforcementLookups.enforcementActionAreas
              })
            })
          );
          NProgress.done();
        })
        .fail(function(err) {
          NProgress.done();
        });
    })
    .fail(function(err) {
      NProgress.done();
    });
};
